/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Show_Event_ButtonInputs */

const en_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Event`)
};

const fr_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher l'evenement`)
};

const de_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung anzeigen`)
};

const it_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra evento`)
};

const ru_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выставочное мероприятие`)
};

const es_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar evento`)
};

const zh_cn2_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演出活动`)
};

const ja_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを表示`)
};

const hi_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम दिखाएँ`)
};

const pt_pt2_timing_sync_show_event_button = /** @type {(inputs: Timing_Sync_Show_Event_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de Exibição`)
};

/**
* | output |
* | --- |
* | "Show Event" |
*
* @param {Timing_Sync_Show_Event_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_show_event_button = /** @type {((inputs?: Timing_Sync_Show_Event_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Show_Event_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_show_event_button(inputs)
	if (locale === "de") return de_timing_sync_show_event_button(inputs)
	if (locale === "it") return it_timing_sync_show_event_button(inputs)
	if (locale === "ru") return ru_timing_sync_show_event_button(inputs)
	if (locale === "es") return es_timing_sync_show_event_button(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_show_event_button(inputs)
	if (locale === "ja") return ja_timing_sync_show_event_button(inputs)
	if (locale === "hi") return hi_timing_sync_show_event_button(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_show_event_button(inputs)
	return en_timing_sync_show_event_button(inputs)
});